import { TariffField } from "./tariffField";

export class SelectOption {
  constructor(id, label, value, fields) {
    this.id = id;
    this.label = label || value;
    this.value = value
    this.fields = fields;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SelectOption(input.id,
        input.label,
        input.value,
        Array.isArray(input.fields) ? TariffField.fromApiArray(input.fields) : input.fields
      )
    }
    return new SelectOption();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => SelectOption.fromApiObject(item));
    }
    if (typeof (input) === "object") {
      return [SelectOption.fromApiObject(input)];
    }
    return [];
  }
}